/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rooms_Restart_NumberingInputs */



/**
* | output |
* | --- |
* | "Restart numbering in each room" |
*
* @param {Rooms_Restart_NumberingInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rooms_restart_numbering = /** @type {((inputs?: Rooms_Restart_NumberingInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rooms_Restart_NumberingInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Recommencer la numérotation dans chaque salle")
	if (locale === "es") return /** @type {LocalizedString} */ ("Reiniciar la numeración en cada sala")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Reiniciar a numeração em cada sala")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ricomincia la numerazione in ogni sala")
	return /** @type {LocalizedString} */ ("Restart numbering in each room")
});